// Layout breakpoint between mobile and desktop. Used by both JS (store.js)
// and CSS (sidebar component styles, referenced as a media query).
// Keep this number in sync with any media queries that reference 1280px.
export const MOBILE_BREAKPOINT_PX = 1280;
